export interface IPage {
  pageId: string
  stage: string
}

export const accreditedPages: IPage[] = [
  { pageId: '1', stage: 'EMAIL' },
  { pageId: '2', stage: 'INVESTOR_TYPE' },
  { pageId: '2a', stage: 'JOINT_ACCOUNT_TYPE' },
  { pageId: '3', stage: 'INVESTOR_PERSONAL_INFO' },
  { pageId: '4', stage: 'SOCIAL_SECURITY_NUM' },
  { pageId: '5', stage: 'INVESTMENT_AMOUNT' },
  { pageId: '6', stage: 'ACCREDITED_INVESTOR_TYPE' },
  { pageId: '6A-1', stage: 'ACCREDITATION_STEP_1' },
  { pageId: '6A-2', stage: 'ACCREDITATION_STEP_2' },
  { pageId: '7', stage: 'PAYMENT_SELECTION' },
  { pageId: '8', stage: 'PAYMENTS' },
  { pageId: '9', stage: 'PAYMENT_PROCESSING' },
]

export const unAccreditedPages: IPage[] = [
  { pageId: '1', stage: 'EMAIL' },
  { pageId: '2', stage: 'INVESTOR_TYPE' },
  { pageId: '2a', stage: 'JOINT_ACCOUNT_TYPE' },
  { pageId: '3', stage: 'INVESTOR_PERSONAL_INFO' },
  { pageId: '4', stage: 'SOCIAL_SECURITY_NUM' },
  { pageId: '5', stage: 'INVESTMENT_AMOUNT' },
  { pageId: '6', stage: 'ACCREDITED_INVESTOR_TYPE' },
  { pageId: '6B-1', stage: 'UNACCREDITED' },
  { pageId: '7', stage: 'PAYMENT_SELECTION' },
  { pageId: '8', stage: 'PAYMENTS' },
  { pageId: '9', stage: 'PAYMENT_PROCESSING' },
]

export const stepperPages = []
